<div class="signals-list-container">
  <table class="signal-list-table" mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="checkbox">
      <th mat-header-cell *matHeaderCellDef class="checkbox-cell">
        <mat-checkbox
          class="select-all"
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [disabled]="disabled"
          [color]="'primary'"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
          [ngClass]="{
            'checked-primary':
              (selection.hasValue() && isAllSelected()) ||
              (selection.hasValue() && !isAllSelected())
          }"
          >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        @if (!row.finished) {
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="selectionChanged($event, row)"
            [checked]="selection.isSelected(row)"
            [disabled]="disabled"
            [color]="'primary'"
            [ngClass]="{ 'checked-primary': selection.isSelected(row) }"
            >
          </mat-checkbox>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="parkName">
      <th mat-header-cell *matHeaderCellDef class="data-cell">
        {{ "COMMON.ASSET" |translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.parkDisplayName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="turbine">
      <th mat-header-cell *matHeaderCellDef class="data-cell">
        {{ "COMMON.DEVICE" |translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ (element.device | noUnderscore) || element.parkDisplayName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="deviceType">
      <th mat-header-cell *matHeaderCellDef class="data-cell">
        {{ "DATA_STUDIO.DATA_ANALYSIS.DEVICE_TYPE" |translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.deviceType }}
      </td>
    </ng-container>

    <ng-container matColumnDef="signal">
      <th mat-header-cell *matHeaderCellDef class="data-cell">
        Signal [unit]
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.signalName }} [{{ element.unit }}]
        @if (!element.chartData?.length && !loadingSerie) {
          <i
            class="far fa-exclamation-circle custom-exclamation-icon"
            [matTooltip]="'No Data'"
          ></i>
        }
        @if (loadingSerie && element.newItem) {
          <span class="font-size-very-small text-tertiary">
            {{ "COMMON.LOADING" |translate }}
          </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="granularity">
      <th mat-header-cell *matHeaderCellDef class="data-cell">
        {{ "DATA_STUDIO.DATA_PARAMETERS.GRANULARITY" |translate }}
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="d-flex justify-content-center align-items-center">
          <div class="chart-type">
            <lib-select
              [options]="granOptions.values"
              [label]="element.granularity"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100'"
              [itemClasses]="'font-size-normal-small'"
              [fullWidth]="true"
              [doNotTranslate]="true"
              [disabled]="disabled || !element.visible"
              [container]="'body'"
              [placement]="i >= dataSource?.data?.length - 3 ? 'top-right' : 'bottom-right'"
              (selectedChanged)="selectchartGranularity($event, element)">
            </lib-select>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="color">
      <th mat-header-cell *matHeaderCellDef class="data-cell">
        {{ "DATA_STUDIO.PREVIEW.COLOR" |translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex justify-content-center align-items-center">
          <input id="color-picker"
            type="color"
            class="color-selector input form-control"
            [disabled]="disabled || !element.visible"
            [ngStyle]="{'color-scheme': theme}"
            [(ngModel)]="element.color"
            list="defaultColors"
            (ngModelChange)="changeColor(element)">

          <datalist id="defaultColors">
            @for (color of defaultColorList; track $index) {
              <option class="option-color">{{ color }}</option>
            }
          </datalist>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="style">
      <th mat-header-cell *matHeaderCellDef class="data-cell">
        {{ "DATA_STUDIO.PREVIEW.STYLE" |translate }}
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="d-flex justify-content-center align-items-center">
          <div class="chart-type">
            <lib-select
              [options]="chartTypes.names"
              [label]="element.chartTypeName"
              [border]="'custom-border'"
              [classes]="'font-size-normal-small text-primary h-100'"
              [itemClasses]="'font-size-normal-small'"
              [fullWidth]="true"
              [doNotTranslate]="false"
              [disabled]="disabled || !element.visible"
              [container]="'body'"
              [placement]="i >= dataSource?.data?.length - 3 ? 'top-right' : 'bottom-right'"
              (selectedChanged)="selectchartType($event, element)">
            </lib-select>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef class="border-left actions-cell">
        {{ "DATA_STUDIO.PREVIEW.ACTIONS" |translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="border-left">
        <div class="d-flex justify-content-center">
          @if (!element.visible) {
            <div class="action-icon pr-2">
              <lib-button
                id="data-studio-table-series-eye-slash"
                [size]="'custom'"
                [color]="'primary-link'"
                [fontSize]="24"
                [disabled]="disabled"
                class="mr-2"
                [faIcon]="'far fa-eye-slash'"
                (click)="toggleVisibility(element)" >
              </lib-button>
            </div>
          }
          @if (element.visible) {
            <div class="action-icon pr-2">
              <lib-button
                id="data-studio-table-series-eye"
                [size]="'custom'"
                [color]="'primary-link'"
                [disabled]="disabled"
                [fontSize]="24"
                class="mr-2"
                [faIcon]="'far fa-eye'"
                (click)="toggleVisibility(element)">
              </lib-button>
            </div>
          }
          <lib-select
            id="overview-component-select-option"
            [options]="['BUTTONS.DELETE']"
            [classes]="'text-primary text-left font-size-normal cursor-pointer'"
            [withIcon]="true"
            [arrowColor]="'text-tertiary'"
            [placement]="'bottom left'"
            [showCaret]="false"
            [inactiveOptionClasses]="''"
            [disabled]="disabled"
            [container]="''"
            (selectedChanged)="selectOption(element)">
            <ng-container icon>
              <i class="far fa-ellipsis-h font-icons pointer"></i>
            </ng-container>
          </lib-select>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{'new-row': row.newItem}"></tr>
  </table>
</div>